<template>
  <v-expansion-panel-header>
    <h3 class=" py-2 font-weight-bold text-no-wrap">
      {{ titulo }}
    </h3>

    <secao-personalizada-impressao-dialog
      :is-imprimir-secao-dialog-open.sync="isImprimirSecaoDialogOpen"
      :ticket-id="ticketId"
      :formulario-id="formularioId"
      :qtd-colunas="qtdColunas"
      :elementos="elementosVersaoImpressao"
      :solicitante-data="solicitanteData"
      :componente-text-label-options="componenteTextLabelOptions"
    />

    <div
      v-if="impressaoDisponivel"
      class="d-flex justify-end mr-2"
    >
      <v-btn
        fab
        x-small
        @click.native.stop="isImprimirSecaoDialogOpen = !isImprimirSecaoDialogOpen"
      >
        <v-icon>
          {{ icons.mdiFilePdfBox }}
        </v-icon>
      </v-btn>
    </div>
  </v-expansion-panel-header>
</template>

<script>
import { mdiFilePdfBox } from '@mdi/js'
import { ref } from '@vue/composition-api'
import SecaoPersonalizadaImpressaoDialog from './SecaoPersonalizadaImpressaoDialog.vue'
import ComponenteTextLabelOptions from '@/models/props/ComponenteTextLabelOptions'

export default {
  components: {
    SecaoPersonalizadaImpressaoDialog,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    formularioId: {
      type: Number,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    qtdColunas: {
      type: Number,
      required: true,
    },
    solicitanteData: {
      type: Object,
      required: true,
    },
    impressaoDisponivel: {
      type: Boolean,
      required: true,
    },
    elementosVersaoImpressao: {
      type: Array,
      required: true,
    },
    componenteTextLabelOptions: {
      type: ComponenteTextLabelOptions,
      default: null,
    },
  },

  setup() {
    const isImprimirSecaoDialogOpen = ref(false)

    return {
      isImprimirSecaoDialogOpen,
      icons: {
        mdiFilePdfBox,
      },
    }
  },
}
</script>
